import { useNavigate } from "react-router-dom";
import FadeInWhenVisible from "../components/Fade";
import { myServices } from "../data";

function Service() {
  const formatServiceTitle = (title) =>
    title.toLowerCase().replace(/[^a-z0-9]/g, "-");


  const navigate = useNavigate();

  const handleViewMore = (serviceTitle) => {
    navigate(`/services/${formatServiceTitle(serviceTitle)}`);
  };

  return (
    <section id="services" className="service flex flex-col">
      <FadeInWhenVisible>
        <div className="service-text flex flex-col justify-center items-center">
          <p className="sv">Our Solutions</p>
          <h2 className="sm:text-2xl font-bold">What Service We Offer</h2>
          <h2 className="text-sm tracking-tight">Dive into our suite of mobile services designed to entertain, engage, and empower</h2>
        </div>
      </FadeInWhenVisible>

      <div className="service-card-cont">
        {myServices.map((service) => (
          <div className="service-card flex-col" key={service.id}>
            <div>
              <h2 className="text-3xl font-bold mb-2">{`0${service.id}`}</h2>
              <img src={service.icon} className="service-icon" alt="service-icon" />
            </div>
            <h4 className="font-bold">{service.title}</h4>
            <p>{service.description}</p>
            <button
              onClick={() => handleViewMore(service.title)}
              className="text-left text-blue-900 font-bold mt-4 cursor-pointer"
            >
              View More &#8594;
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Service;

